import React from 'react';
import showcase1 from '../assets/images/showcase-1.png';
import showcase2 from '../assets/images/showcase-2.png';
import showcase3 from '../assets/images/showcase-3.png';
import showcase4 from '../assets/images/showcase-4.png';

export default function TopHero() {
  return (
    <section className="top hero">
      <div className="container hero-grid">
        <div className="hero-left">
          <div className="headline big">Too many goals?</div>
          <div className="headline gradient">Don't overthink it —</div>
          <div className="headline gradient">Moro it.</div>
          <p className="hero-copy">You’re not alone — thousands of people do the same daily task with you. Different lives, same small step. Together, we grow through simplicity.</p>
          <a className="btn btn-pill btn-accent" href="#cta">Join Waitlist</a>
        </div>
        <div className="hero-right">
          <div className="hero-panel">
            <div className="hero-showcase" aria-label="App screenshots">
              <img className="shot shot1" src={showcase3} alt="Moro screenshot 1" />
              <img className="shot shot2" src={showcase1} alt="Moro screenshot 2" />
              <img className="shot shot3" src={showcase2} alt="Moro screenshot 3" />
              <img className="shot shot4" src={showcase4} alt="Moro screenshot 4" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}